import { useFrame } from "react-frame-component";

// returns the document of the frame if it exists, otherwise the main document
// and a boolean indicating if the current component is inside a frame
export const useFrameDocument = () => {
  const { document: frameDocument } = useFrame();
  const targetDocument = frameDocument || document;
  const isInFrame = frameDocument && frameDocument !== document;
  return {
    frameDocument: targetDocument,
    isInFrame,
  };
};
